import { Injectable, signal } from '@angular/core';
import { BaseHttpService } from '@shared/services/base-http.service';
import { ApplicationConfiguration as AppConfig, TenantDto } from '../interfaces';
import { Tenant } from '../models';
import { forkJoin } from 'rxjs';
import { InforiusApps } from '@devinforius/i-essentials';

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfiguration extends BaseHttpService {
  protected endPoint: string = 'Global/Configuration';

  private readonly _config = signal<AppConfig>({} as AppConfig);
  public readonly config = this._config.asReadonly();

  private readonly _tenant = signal<Tenant>(new Tenant());
  public readonly tenant = this._tenant.asReadonly();

  public init(): this {
    forkJoin({
      config: this.http.get<AppConfig>(this.buildURL()),
      tenant: this.http.get<TenantDto>(this.buildURL({ apiScope: 'iAdmin', overrideEndPoint: 'Global/TenantInfo' })),
    }).subscribe({
      next: ({ config, tenant }) => {
        this._config.set(config);

        this._tenant.set(
          new Tenant()
            .setActive(tenant.active)
            .setDescription(tenant.description)
            .setApps(
              tenant.applications.map((app) => ({
                identifier: app.type,
                name: app.name as InforiusApps,
                active: app.active,
              }))
            )
        );
      },
    });
    this.http.get<AppConfig>(this.buildURL()).subscribe({
      next: (config) => this._config.set(config),
    });

    return this;
  }
}
